import "../../common/js/polyfills"
import Bugsnag from "@bugsnag/js"
import Alpine from "alpinejs"
import fraudNetIntegration from "./fraudNetIntegration"
import commonTrackingPageInit from "./services/tracking/trackingPageInit"
import translation from "../../common/js/translation"
import { getOrderData } from "./getOrderData"

function handleImageLoad(img) {
  if (img.complete) {
    // Image was already loaded from cache
    window.requestAnimationFrame(() => {
      img.classList.add("pipe-img-loaded")
    })
  } else {
    // Wait for image to load
    img.onload = () => img.classList.add("pipe-img-loaded")
  }
}

function watchForNewImages() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === "IMG") {
          handleImageLoad(node)
        } else if (node.querySelectorAll) {
          // Potentially the whole chunk of HTML can be added,
          // which may contain multiple imgs inside
          node.querySelectorAll("img").forEach(handleImageLoad)
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

function handleDOMContentLoaded() {
  const body = document.querySelector("body")

  // Add a CSS class to trigger animation
  window.requestAnimationFrame(() => {
    body.classList.add("pipe-dom-content-loaded")
  })

  const svgs = document.querySelectorAll("svg[data-pipe-svg-animation]")
  svgs.forEach((svg) => {
    window.requestAnimationFrame(() => {
      svg.classList.add("pipe-svg-loaded")
    })
  })

  const imgs = document.querySelectorAll("img")
  imgs.forEach(handleImageLoad)
  watchForNewImages()
}

const BUGSNAG_API_KEY = "a383d74fed09040a8180a6388ef025f7"

export default ({
  components,
  dataStore,
  trackingPageInit,
  bugsnagApiKey,
  DOMContentLoadedCallback,
}) => {
  // Init Bugsnag
  bugsnagApiKey = bugsnagApiKey || BUGSNAG_API_KEY
  Bugsnag.start({ apiKey: bugsnagApiKey, appVersion: appVersion })

  // DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => {
    handleDOMContentLoaded()

    if (DOMContentLoadedCallback) DOMContentLoadedCallback()
  })

  // Init Alpine
  window.Alpine = Alpine

  components.forEach(({ name, data }) => {
    Alpine.data(name, data)
  })

  getOrderData(dataStore).then(async () => {
    Alpine.store("data", dataStore)
    Alpine.start()
    translation.onInit()
  })

  // Init internal analytics tracking
  trackingPageInit = trackingPageInit || commonTrackingPageInit
  trackingPageInit()

  // Init FraudNet
  fraudNetIntegration()
}
